import { useSelector } from 'react-redux'
import { Filters } from '~/app/features/Gallery/components/Filters'
import { usePersonalizationConfig } from '~/app/features/Gallery/hooks/usePersonalizationConfig'
import { PersonalizationCard } from '@vp/design-personalization-widget'
import { selectFilters } from '~/app/store/filter'
import type { State } from 'shared/types/gallery/state'

export const FiltersSidebar = () => {
  const { isEnabled, mode, imageCopyKey } = usePersonalizationConfig()
  const hasVisibleFilters = useSelector((state: State.GlobalState) => selectFilters(state).some((f) => !f.hidden))
  const showPersonalization = isEnabled && mode === 'sidebar'
  const showAlternativeHeader = showPersonalization && hasVisibleFilters

  return (
    <nav className="left-nav">
      {showPersonalization && <PersonalizationCard />}
      <Filters showAlternativeHeader={showAlternativeHeader} showColorFirst={showPersonalization && imageCopyKey !== 'Photo'} />
    </nav>
  )
}

FiltersSidebar.displayName = 'FiltersSidebar'
